import React, { useContext } from 'react';
import {
  Placeholder,
  ComponentRendering,
  ComponentParams,
  ComponentFactory,
  Field,
  SitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';

import './index.scss';
import { APIWebstoreContext } from '../../context/globalContext';

export type UnifiedPaymentDetailsProps = {
  fields: {
    Heading: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
  invoiceIdentifier?: string;
};

interface Props {
  children: React.ReactElement;
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
}

const UnifiedPaymentDetails = (
  props: Props & { invoiceIdentifier?: string }
): React.JSX.Element => {
  const { invoiceIdentifier } = props;
  const { state } = useContext(APIWebstoreContext);

  const hasInvalidInvoices = state?.hasInvalidInvoices;

  return (
    <div className={`unified-payment-details ${hasInvalidInvoices ? 'full-width' : ''}`}>
      <Placeholder
        name="invoice_container"
        rendering={props.rendering}
        invoiceIdentifier={invoiceIdentifier}
      />

      {!hasInvalidInvoices && (
        <Placeholder
          name="payment_container"
          rendering={props.rendering}
          invoiceIdentifier={invoiceIdentifier}
        />
      )}
    </div>
  );
};

export default UnifiedPaymentDetails;
